import { render, staticRenderFns } from "./LookProof.vue?vue&type=template&id=50343d1c&scoped=true"
import script from "./LookProof.vue?vue&type=script&lang=js"
export * from "./LookProof.vue?vue&type=script&lang=js"
import style0 from "./LookProof.vue?vue&type=style&index=0&id=50343d1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50343d1c",
  null
  
)

export default component.exports